module.exports = __webpack_public_path__ + "static/media/20190805_50Days2019_Tag33_1652AT.d1c64913.jpg";